import { FC } from 'react';

import { MpOl } from 'shared/ui/MpOl';
import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpText } from 'shared/ui/MpText';
import { MpUl } from 'shared/ui/MpUl';

export const SpurtDescription: FC = () => (
	<>
		<MpParagraph style={{ marginBottom: `12px` }}>
			SPURT — это твой бизнес-помощник для полноценного управления бизнесом.
			<br />
			<br />
			Кому подойдет приложение:
		</MpParagraph>
		<MpOl style={{ gap: `12px`, marginBottom: `24px` }}>
			<li>
				<MpText>
					<strong>Управляющему</strong>
					<br />
					Помогает оперативно корректировать работу команды в течение смены
				</MpText>
			</li>
			<li>
				<MpText>
					<strong>Территориальному / региональному управляющему</strong>
					<br />
					Все показатели под рукой. Позволяет принимать решения на основе моментальных отчетов по заведениям и
					отслеживать цели в динамике
				</MpText>
			</li>
			<li>
				<MpText>
					<strong>Операционному директору</strong>
					<br />
					Быстрый контроль работы сети заведений
				</MpText>
			</li>
			<li>
				<MpText>
					<strong>Партнеру</strong>
					<br />
					Ваши основные бизнес-метрики перед глазами в любую минуту
				</MpText>
			</li>
		</MpOl>
		<MpParagraph>SPURT сам:</MpParagraph>
		<MpUl style={{ gap: `0`, marginBottom: `0` }}>
			<li>
				<MpText>собирает аналитику</MpText>
			</li>
			<li>
				<MpText>формирует отчеты</MpText>
			</li>
			<li>
				<MpText>контролирует уведомления</MpText>
			</li>
		</MpUl>
		<MpParagraph style={{ marginBottom: `24px` }}>Вам остается только управлять.</MpParagraph>
		<MpParagraph>
			Баланс эффективности, выручка, списания, стопы, скорость приготовления и доставки, отклики и аналитика — все
			метрики у вас в телефоне. А если нет нужных — достаточно просто написать в SPURT и мы оперативно добавим.
		</MpParagraph>
	</>
);
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SpurtDescription_eng: FC = () => (
	<>
		<MpParagraph style={{ marginBottom: `12px` }}>
			SPURT is your business assistant for comprehensive business management.
			<br />
			<br />
			Who the application is suitable for:
		</MpParagraph>
		<MpOl style={{ gap: `12px`, marginBottom: `24px` }}>
			<li>
				<MpText>
					<strong>Manager</strong>
					<br />
					Helps adjust team operations promptly during shifts.
				</MpText>
			</li>
			<li>
				<MpText>
					<strong>Territorial/Regional Manager</strong>
					<br />
					All indicators at your fingertips. Enables decision-making based on instant reports on
					establishments and tracking goals dynamically.
				</MpText>
			</li>
			<li>
				<MpText>
					<strong>Operations Director</strong>
					<br />
					Quick control of the network of establishments.
				</MpText>
			</li>
			<li>
				<MpText>
					<strong>Partner</strong>
					<br />
					Your key business metrics in front of you at any moment.
				</MpText>
			</li>
		</MpOl>
		<MpParagraph>SPURT itself:</MpParagraph>
		<MpUl style={{ gap: `0`, marginBottom: `0` }}>
			<li>
				<MpText>collects analytics</MpText>
			</li>
			<li>
				<MpText>generates reports</MpText>
			</li>
			<li>
				<MpText>controls notifications</MpText>
			</li>
		</MpUl>
		<MpParagraph style={{ marginBottom: `24px` }}>All you have to do is manage.</MpParagraph>
		<MpParagraph>
			Balance of efficiency, revenue, write-offs, rates, preparation and delivery speed, feedback, and analytics —
			all metrics are on your phone. And if the necessary ones are not available — just write to SPURT, and we
			will add them promptly.
		</MpParagraph>
	</>
);
